import { SearchDocumentType } from '../../api/api.types';
export var SEARCH_DOCUMENT_TYPES = [
    SearchDocumentType.Pages,
    SearchDocumentType.Products,
    SearchDocumentType.Blogs,
];
export function getSearchDocumentTypesResponse(documentTypes) {
    return {
        sources: documentTypes.map(function (documentType) { return ({ documentType: documentType }); }),
    };
}
//# sourceMappingURL=searchDocumentTypesResponse.js.map